import React, { useCallback, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import { SIZES } from 'src/styles/theme'
import { Link } from 'react-router-dom'

const StyledModal = styled(Modal)`
  .modal-content {
    border: none;
    background: transparent;
    border-radius: 0;
  }
  .box-dialog {
    border-radius: 3px;
    width: 90%;
    margin: 0 auto;
    max-height: 70vh;
    max-width: 600px;
    background-color: rgba(0, 0, 0, 0.7);
    text-align: center;
    padding: 10px 20px 10px 0px;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    a {
      display: block;
      font-size: 1.9em;
      font-weight: bold;
      text-transform: uppercase;
      letter-spacing: 2px;
      color: #44ABE2;
      text-decoration: none;
      margin-top: 5px;

      span {
        margin-right: 8px;
        visibility: hidden;
      }

      &:hover {
        filter: brightness(1.5);
        span {
          visibility: visible;
        }
      }
    }
  }
  ${SIZES.mobile} {
    .box-dialog {
      a {
        font-size: 16px;
        letter-spacing: 0;
      }
    }
  }
`
const destinations = [
  {
    id: 3,
    name: "Similac Gold Gain Plus",
    route: "/booths/35"
  },
  {
    id: 1,
    name: "PediaSure",
    route: "/booths/1"
  },
  {
    id: 2,
    name: "Similac Total Comfort",
    route: "/booths/2"
  },
]

export default function ExhibitionEntryModal({ showModal, hideModal }) {
  const escFunction = useCallback(
    (event) => {
      if (event.keyCode === 27) {
        hideModal()
      }
    },
    [hideModal]
  )

  const clickOutsideToClose = (e) => {
    if ((e.target).id === 'ENTRY_SELECTION_MODAL') {
      hideModal()
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false)

    return () => {
      document.removeEventListener('keydown', escFunction, false)
    }
  }, [escFunction])

  return (
    <StyledModal id={'ENTRY_SELECTION_MODAL'} show={showModal} onHide={hideModal} aria-labelledby="game-modal" size="lg" centered onClick={clickOutsideToClose}>
      <div className="box-dialog">
        {destinations.map((entry) => (
          <Link key={entry.name} to={entry.route} onClick={hideModal}>
            <span>→</span>
            {entry.name}
          </Link>
        ))}
      </div>
    </StyledModal>
  )
}
